import { render } from "./waterMarkIcon.vue?vue&type=template&id=b1203dc6"
import script from "./waterMarkIcon.vue?vue&type=script&lang=js"
export * from "./waterMarkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__